import axios from 'axios';
import { showUnauthorizedModal } from '../layout';

export const defaultRequest = async (config, form) => {
    var url = new URL(process.env.REACT_APP_EVERSALES_BACKEND_API + config.endpoint)
    // var url = new URL('http://webapps01.acom.net.br:8091/' + config.endpoint)

    var data = {}

    const token = localStorage.getItem('userToken')

    var headers = {
        'Content-Type': 'application/json'
    }

    if (token){
        headers['Authorization'] = 'Bearer ' + token
    }

    if (config.method === 'get' || config.method === 'delete') {
        url.search = new URLSearchParams(form)
    } 
    else if (config.method === 'post' || config.method === 'put') {
        data = form
    }

    var funcResponse = {}

    try {
        const response = await axios({
            headers: headers,
            method: config.method.toLowerCase(),
            url: url.toString(),
            data: data
        })

        funcResponse = {
            status: true,
            data: response.data
        }
    } catch (error) {
        if (error.response) {
            if (error.response.status === 401) {
                localStorage.removeItem('userToken')
                showUnauthorizedModal()
                funcResponse = {
                    status: false,
                    data: {
                        message: 'Não autorizado'
                    }
                }
            } else {
                // Caso contrário, devolve a resposta de erro
                funcResponse = {
                    status: false,
                    data: error.response.data || { message: 'Erro desconhecido' }
                }
            }
        } else {
            funcResponse = {
                status: false,
                data: { message: 'Erro de rede ou servidor inacessível' }
            }
        }
    }    

    return funcResponse   
}

export const getCityOptionsRequest = (component, uf) => {
    let config = {
        method: 'get',
        endpoint: 'list/city'
    }
    let form = {
        uf: uf 
    }
    return defaultRequest(config, form)
}

export const optionsRequest = (component, optionList) => {
    let config = {
        method: 'get',
        endpoint: 'list/options'
    }
    let form = {
        optionList: JSON.stringify(optionList)
    }
    defaultRequest(config, form).then((r) => {
        if (r.status) {
            var newState = {}
            for ( let key in r.data ) {
                if (!['status', 'message'].includes(key)) {
                    if (r.data.hasOwnProperty(key)) {
                        const camelCase = key.replace(/_([a-z])/g, (g) => g[1].toUpperCase())
                        newState[camelCase] = r.data[key]
                    }
                }
            }
            newState['isLoadingOptions'] = false

            component.setState(prevState => ({ 
                ...prevState, ...newState 
            }))
        }
    })
}

export const optionsRequestFiltered = (component, optionList, term) => {
    let config = {
        method: 'get',
        endpoint: 'list/options/filtered'
    }
    let form = {
        optionList: JSON.stringify(optionList),
        term: term
    }
    defaultRequest(config, form).then((r) => {
        if (r.status) {
            var newState = {}
            for ( let key in r.data ) {
                if (!['status', 'message'].includes(key)) {
                    if (r.data.hasOwnProperty(key)) {
                        const camelCase = key.replace(/_([a-z])/g, (g) => g[1].toUpperCase())
                        newState[camelCase] = r.data[key]
                    }
                }
            }
            newState['isLoadingOptions'] = false

            component.setState(prevState => ({ 
                ...prevState, ...newState 
            }))
        }
    })
}